import styled from "@emotion/styled";

export const CancelContainer = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 40px;
  gap: 20px;
`;

export const TitleContainer = styled.div`
  display: flex;
  padding-bottom: 20px;
  align-items: center;
  gap: 8px;
  border-bottom: 1px solid var(--alias-color-line-normal);
`;

export const TopSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const InfoConatiner = styled.div`
  display: flex;
  padding: 16px;
  align-items: center;
  gap: 8px;

  border-radius: 8px;
  background: var(--global-color-blue-98);
`;

export const SectionContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-direction: column;
  align-items: flex-start;
`;

export const AllSelectContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const CalendarListContainer = styled.div`
  display: flex;
  height: 320px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  overflow-y: auto;
  width: 100%;
`;

export const CalendarItemContainer = styled.div`
  display: flex;
  width: 100%;
  box-sizing: border-box;
  padding: 16px;
  justify-content: center;
  align-items: center;
  gap: 12px;
  cursor: pointer;

  border-radius: 10px;
  border: 1px solid var(--alias-color-line-normal);
  background: var(--color-background-normal-normal);
`;

export const CalendarItemInfoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;

  .vertical {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 4px;
  }
  .horizontal {
    display: flex;
    align-items: center;
    gap: 4px;
  }
`;

export const BtnContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
`;

export const PrivateToogleContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;

  .horizontal1 {
    display: flex;
    align-items: center;
    gap: 4px;
  }
`;
